



/**********************************************************************
 * AGC COLLECTION FILTER SYSTEM (FINAL FIXED VERSION)
 * Supports:
 *  ✔ Product Type (filter.p.product_type)
 *  ✔ Season       (filter.p.m.custom.agc_grassseason)
 *  ✔ Grass Type   (filter.p.m.custom.agc_grasstype)
 *
 * Fully corrected:
 *  ✔ No more disappearing season filters when ONLY grass selected
 *  ✔ GrassTypes apply ONLY when user selects a grass filter
 *  ✔ Seasons without grassTypes (Winter) remain valid unless filtered out
 ***********************************************************************/


/* ==========================================================================
   1. LOAD PRODUCTS FROM SHOPIFY STOREFRONT API
========================================================================== */
/*******************************************
 * DISABLE SHOPIFY NATIVE FILTER SYSTEM
 *******************************************/

// Stop Shopify form submission

document.addEventListener("submit", function(e) {
  if (e.target.closest("form")) {
    if ([...e.target.elements].some(el => el.name?.startsWith("filter.p."))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }
}, true);

// Stop Shopify's change handlers
document.addEventListener("change", function(e) {
  if (e.target.name?.startsWith("filter.p.")) {
    e.stopImmediatePropagation();
  }
}, true);

// Remove Shopify's filter query parameters
if (window.location.search.includes("filter.p.")) {
  const cleanURL = window.location.origin + window.location.pathname;
  window.history.replaceState({}, "", cleanURL);
}

// Mark Shopify filter forms as disabled
document.querySelectorAll("form").forEach(form => {
  if ([...form.elements].some(el => el.name?.startsWith("filter.p."))) {
    form.setAttribute("data-agc-disabled", "true");
    form.addEventListener("submit", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    });
  }
});
 
const AGC_QUERY = `
{
  collection(handle: "lawn-fertilizer") {
    products(first: 250) {
      nodes {
        id
        title
        handle
        tags

        metafield(namespace: "custom", key: "agc_season_compatibility") {
          value
        }

        metafield_productType: metafield(namespace: "custom", key: "agc_product_type") {
          value
        }

        metafield_grass: metafield(namespace: "custom", key: "agc_grasstype") {
          value
        }
      }
    }
  }
}
`;

window.AGC_ProductsById = {};

fetch('/api/2023-10/graphql.json', {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": "f0f942a442d479117afa707d0ed072d5"
  },
  body: JSON.stringify({ query: AGC_QUERY })
})
.then(res => res.json())
.then(data => {

  const products = data?.data?.collection?.products?.nodes ?? [];

  products.forEach(p => {
    const cleanId = p.id.split("/").pop();
    p.id_clean = cleanId;

    /* -------------------------------------------------------
       PARSE SEASONS METAFIELD JSON
    -------------------------------------------------------- */
    p.seasons = [];
    if (p.metafield?.value) {
      try {
        p.seasons = JSON.parse(p.metafield.value).seasons || [];
      } catch { p.seasons = []; }
    }

    /* -------------------------------------------------------
       PRODUCT TYPE
    -------------------------------------------------------- */
    if (p.metafield_productType?.value) {
      p.product_type = p.metafield_productType.value;
    } else {
      p.product_type = p.tags?.find(tag =>
        ["Lawn Fertilizer", "Insecticide", "Granular"].includes(tag)
      ) || null;
    }

    /* -------------------------------------------------------
       GRASS TYPES METAFIELD (if any)
    -------------------------------------------------------- */
    p.grass_types = [];
    if (p.metafield_grass?.value) {
      try { p.grass_types = JSON.parse(p.metafield_grass.value); } catch {}
    }

    window.AGC_ProductsById[cleanId] = p;
  });

  console.log("AGC Products Loaded:", window.AGC_ProductsById);

  AGC_RunFilters();              // initial filter pass
  AGC_AdjustSeasonFilterOptions(); // adjust season filter UI based on metafields
});


/* ==========================================================================
   2. LISTEN FOR SHOPIFY FILTER CHECKBOXES
========================================================================== */

document.addEventListener("change", function (e) {
  const n = e.target.name;

  if (
    n === "filter.p.product_type" ||
    n === "filter.p.m.custom.agc_grassseason" ||
    n === "filter.p.m.custom.agc_grasstype"
  ) {
    AGC_RunFilters();
  }
});


/* ==========================================================================
   3. MAIN FILTER ENGINE
========================================================================== */

function AGC_RunFilters() {

  const selectedTypes  = getSelected("filter.p.product_type");
  const selectedSeason = getSelected("filter.p.m.custom.agc_grassseason");
  const selectedGrass  = getSelected("filter.p.m.custom.agc_grasstype");

  const cards = document.querySelectorAll(".product-card");

  cards.forEach(card => {

    const pid = card.dataset.productId;
    const p = window.AGC_ProductsById[pid];
    if (!p) { card.style.display = "none"; return; }

    let show = true;

    /* PRODUCT TYPE MATCH */
    if (selectedTypes.length > 0 && !selectedTypes.includes(p.product_type)) {
      show = false;
    }

    /* SEASON MATCH */
    if (selectedSeason.length > 0) {
      const productSeasonNames = p.seasons.map(s => s.name);
      if (!selectedSeason.some(s => productSeasonNames.includes(s))) {
        show = false;
      }
    }

    /* GRASS TYPE MATCH */
    if (selectedGrass.length > 0) {
      const productGrass = [];
      p.seasons.forEach(s => {
        if (Array.isArray(s.grassTypes)) productGrass.push(...s.grassTypes);
      });

      if (!selectedGrass.some(g => productGrass.includes(g))) {
        show = false;
      }
    }

    card.style.display = show ? "" : "none";
  });

  AGC_UpdateFilterAvailability();
  AGC_UpdateSeasonCounts();

}


/* ==========================================================================
   4. GET SELECTED FILTER VALUES
========================================================================== */

function getSelected(name) {
  return Array.from(document.querySelectorAll(`input[name="${name}"]:checked`))
    .map(cb => cb.value.trim());
}


/* ==========================================================================
   5. GREY-OUT UNAVAILABLE FILTER OPTIONS (FIXED VERSION)
========================================================================== */

function AGC_UpdateFilterAvailability() {
  updateCheckboxGroup("filter.p.product_type");
  updateCheckboxGroup("filter.p.m.custom.agc_grassseason");
  updateCheckboxGroup("filter.p.m.custom.agc_grasstype");
}

/**********************************************************************
 * UPDATE SEASON PRODUCT COUNTS IN SHOPIFY FILTER UI
 **********************************************************************/
function AGC_UpdateSeasonCounts() {

  const checkboxes = document.querySelectorAll(
    'input[name="filter.p.m.custom.agc_grassseason"]'
  );

  const selectedTypes  = getSelected("filter.p.product_type");
  const selectedGrass  = getSelected("filter.p.m.custom.agc_grasstype");

  checkboxes.forEach(cb => {
    const seasonName = cb.value.trim();
    let count = 0;

    // Loop all products and determine how many match this season
    Object.values(window.AGC_ProductsById).forEach(p => {

      const productSeasonNames = p.seasons.map(s => s.name);

      // SEASON MATCH
      const matchesSeason = productSeasonNames.includes(seasonName);

      if (!matchesSeason) return;

      // PRODUCT TYPE MATCH
      if (selectedTypes.length > 0 &&
          !selectedTypes.includes(p.product_type)) return;

      // GRASS TYPE MATCH
      if (selectedGrass.length > 0) {
        const productGrass = [];
        p.seasons.forEach(s => {
          if (Array.isArray(s.grassTypes)) productGrass.push(...s.grassTypes);
        });

        const grassOk = selectedGrass.some(g =>
          productGrass.includes(g)
        );

        if (!grassOk) return;
      }

      // If all checks passed → count this product
      count++;
    });

    // Update UI count
    const label = cb.parentElement.querySelector(".filter__count");
    if (label) label.textContent = `(${count})`;

    // Update availability based on count
    let wrapper = cb.closest("li") || cb.closest("label") || cb.parentElement;

    if (count === 0) {
      cb.disabled = true;
      if (wrapper) wrapper.style.opacity = "0.4";
    } else {
      cb.disabled = false;
      if (wrapper) wrapper.style.opacity = "1";
    }
  });
}


function updateCheckboxGroup(name) {

  const checkboxes = document.querySelectorAll(`input[name="${name}"]`);

  const selectedTypes  = getSelected("filter.p.product_type");
  const selectedSeason = getSelected("filter.p.m.custom.agc_grassseason");
  const selectedGrass  = getSelected("filter.p.m.custom.agc_grasstype");

  checkboxes.forEach(cb => {

    let foundMatch = false;

    const simulated = cb.checked ? [cb.value] : [cb.value];

    Object.values(window.AGC_ProductsById).forEach(p => {

      if (foundMatch) return;

      const seasonNames = p.seasons.map(s => s.name);

      let typeMatch = true,
          seasonMatch = true,
          grassMatch = true,
          groupMatch = true;

      /* ------------------------------
         PRODUCT TYPE GROUP
      ------------------------------ */
      if (name === "filter.p.product_type") {
        groupMatch = simulated.includes(p.product_type);
      } else if (selectedTypes.length > 0) {
        typeMatch = selectedTypes.includes(p.product_type);
      }

      /* ------------------------------
         SEASON GROUP (FIXED LOGIC)
      ------------------------------ */
      if (name === "filter.p.m.custom.agc_grassseason") {

        const productHasSeason = simulated.some(season =>
          seasonNames.includes(season)
        );

        if (!productHasSeason) { groupMatch = false; return; }

        // Only apply grass filter if a grass filter is selected
        if (selectedGrass.length > 0) {

          const productGrass = [];
          p.seasons.forEach(s => {
            if (Array.isArray(s.grassTypes)) productGrass.push(...s.grassTypes);
          });

          const grassMatchForSeason = selectedGrass.some(g =>
            productGrass.includes(g)
          );

          if (!grassMatchForSeason) groupMatch = false;
        }

      } else if (selectedSeason.length > 0) {
        seasonMatch = selectedSeason.some(s => seasonNames.includes(s));
      }

      /* ------------------------------
         GRASS TYPE GROUP
      ------------------------------ */
      const productGrass = [];
      p.seasons.forEach(s => {
        if (Array.isArray(s.grassTypes)) productGrass.push(...s.grassTypes);
      });

      if (name === "filter.p.m.custom.agc_grasstype") {

  // For each grass type being evaluated...
  groupMatch = false;

  simulated.forEach(grassChoice => {

    // Does this product contain ANY season with this grass type?
    const matchesASeason = p.seasons.some(season => {

      const seasonHasGrass =
        Array.isArray(season.grassTypes) &&
        season.grassTypes.includes(grassChoice);

      if (!seasonHasGrass) return false;

      // If user selected seasons, only allow seasons that match
      if (selectedSeason.length > 0) {
        return selectedSeason.includes(season.name);
      }

      // No season filter selected → any valid season counts
      return true;
    });

    if (matchesASeason) {
      groupMatch = true;
    }
  });
} else if (selectedGrass.length > 0) {
        grassMatch = selectedGrass.some(g => productGrass.includes(g));
      }

      /* Final combined match */
      if (typeMatch && seasonMatch && grassMatch && groupMatch) {
        foundMatch = true;
      }
    });

    cb.disabled = !foundMatch;
    let wrapper = cb.closest("li") || cb.closest("label") || cb.parentElement;
if (wrapper) {
  wrapper.style.opacity = foundMatch ? "1" : "0.4";
}
  });
}


/* ==========================================================================
   6. HIDE INVALID SEASON FILTER OPTIONS (BASED ONLY ON METAFIELDS)
========================================================================== */

function AGC_AdjustSeasonFilterOptions() {

  const validSeasons = new Set();

  Object.values(window.AGC_ProductsById).forEach(p => {
    p.seasons.forEach(s => {
      if (s.name) validSeasons.add(s.name.trim());
    });
  });

  const checkboxes = document.querySelectorAll(
    'input[name="filter.p.m.custom.agc_grassseason"]'
  );

  checkboxes.forEach(cb => {
    const seasonName = cb.value.trim();

    if (!validSeasons.has(seasonName)) {
      cb.disabled = true;
      let wrapper = cb.closest("li") || cb.closest("label") || cb.parentElement;
if (wrapper) wrapper.style.display = "none";
    } else {
      cb.disabled = false;
      let wrapper = cb.closest("li") || cb.closest("label") || cb.parentElement;
if (wrapper) wrapper.style.display = "flex";
    }
  });

  console.log("Season filters adjusted:", [...validSeasons]);
}
